
<div class="bkg">
    <div class="wrap-tag" data-aos1="zoom-out-right">
        <img class="cross-icn-pink" [src]="baseElementURL + 'pink-tag.png'">
    </div>
    <div class="header" data-aos="zoom-in-up">
        היכולות של המערכת שלנו:
    </div>
    <div class="wrap-tag"  data-aos="fade-left">
        <img class="cross-icn" [src]="baseElementURL + 'blue-tag.png'">
    </div>
    <div class="all-box-wrap" name="table">
        <div class="row row-box" *ngFor="let row of BoxList" >
            <div class="box" *ngFor="let box of row" [ngStyle]='{"border-radius":box.borderRadius}'>
                <div class="img-wrap">
                    <img data-aos="zoom-in-up" class="img" [src]="baseURL+box.imgUrl">
                </div>
               
                <p [innerHtml]="box.text" class="text"></p>
            </div>
        </div>
    </div>
    <div data-aos="fade-left">
        <img class="cross-icn-boom" [src]="baseElementURL + 'boom.png'">
    </div>
</div>
